<template>
  <div>
    <v-toolbar id="core-toolbar" class="bg-secondary coreToolbar" flat app>
      <v-img
        src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2FUpstream%20Hero%20Logo-03.svg?alt=media&token=1cc7b5b7-6dc1-4c5c-8626-5e01239c037a"
        contain
        class="logo"
        @click="onLogoClick"
      />
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <div
            v-on="on"
            v-if="$vuetify.breakpoint.smAndUp"
            class="white--text mr-4 ml-4"
            v-on:click="$store.dispatch('general/changeType', 'Commercial')"
          >
            <v-img
              src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2Fcommercial%20icon-01%20(1).svg?alt=media&token=6444d739-dfea-499f-838a-421c6acbbb23"
              alt="Commercial Icon"
              contain
              width="25"
              height="25"
              class="mt-2 mx-auto"
              :class="{ selected: siteType == 'Commercial' }"
              @click="$store.dispatch('general/changeType', 'Commercial')"
              style="opacity: 0.5"
            />
            <p
              @click="$store.dispatch('general/changeType', 'Commercial')"
              style="vertical-align: middle; display: inline"
            >
              Commercial
            </p>
          </div>
        </template>
        <span> Customise to Commercial mode by selecting this icon </span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <div v-on="on" v-if="$vuetify.breakpoint.smAndUp" class="white--text">
            <div v-on:click="$store.dispatch('general/changeType', 'Consumer')">
              <v-img
                src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2Fhome%20icon-02%20(1).svg?alt=media&token=593eb756-9ea8-4824-81a9-0c5d6658612e"
                alt="Consumer Icon"
                contain
                width="25"
                height="25"
                class="mt-2 mx-auto"
                :class="{ selected: siteType == 'Consumer' }"
                style="opacity: 0.5"
              />
              <p style="vertical-align: middle; display: inline">Consumer</p>
            </div>
          </div>
        </template>
        <span> Customise to Consumer mode by selecting this iconn </span>
      </v-tooltip>

      <v-spacer />

      <v-spacer />

      <v-menu offset-y :nudge-width="100" left>
        <template v-slot:activator="{ on }">
          <v-btn class="hidden-sm-and-down text-capitalize mr-0" flat v-on="on">
            About <v-icon>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list class="py-0">
          <v-list-tile
            @click="$router.push(item.route)"
            class="pa-2"
            :class="{ borderBottom: index < menu.length - 1 }"
            v-for="(item, index) in menu"
            :key="index"
          >
            <div v-if="$route.path == item.route" class="activeTab"></div>
            <v-list-tile-title>{{ item.label }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-btn
        class="hidden-sm-and-down text-capitalize ml-0"
        color="info"
        square
        @click="$router.push('/searchResults').catch(() => {})"
      >
        Suppliers
      </v-btn>
      <v-combobox
        v-model="searchText"
        v-if="!$vuetify.breakpoint.xs"
        :items="categoryServices"
        :filter="filterSearch"
        prepend-inner-icon="mdi-magnify"
        hide-no-data
        placeholder="Search products & services"
        solo
        clearable
        auto-select-first
        hide-details
        id="searchInput"
        @keyup.enter.native="doSearch()"
        @input="doSearch()"
        :menu-props="{ openOnClick: false }"
        class="roundedSearchBox"
        :class="{ 'mx-2': $vuetify.breakpoint.mdAndUp }"
        :style="`${$vuetify.breakpoint.smAndDown ? 'width: 30px' : ''}`"
        dense
      />
      <v-btn
        @click="mobileSearch = !mobileSearch"
        icon
        v-if="$vuetify.breakpoint.xs"
      >
        <v-icon> mdi-magnify </v-icon>
      </v-btn>

      <v-btn
        v-if="user.auth == null && $vuetify.breakpoint.smAndUp"
        flat
        color="#162c47"
        class="text-capitalize"
        @click="$router.push('/login')"
      >
        Login
      </v-btn>

      <v-menu
        v-if="
          ($vuetify.breakpoint.mdAndUp && user.auth) ||
          $vuetify.breakpoint.smAndDown
        "
        offset-y
        :nudge-width="100"
        left
      >
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon>
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>
        <v-list class="py-0">
          <v-list-tile
            v-if="user.auth != null"
            @click="goToMyProfile"
            class="pa-2 borderBottom"
          >
            <v-list-tile-title>My Profile</v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            class="pa-2"
            style="border-bottom: 1px solid black"
            v-if="
              typeof userData.role != 'undefined' &&
              userData.role.includes('Admin')
            "
            @click="goToNewBackend"
          >
            <v-list-tile-title>Admin</v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            class="pa-2"
            style="border-bottom: 1px solid black"
            v-else-if="
              typeof userData.role != 'undefined' &&
              (userData.role.includes('Business') ||
                userData.role.includes('ImpactBusiness') ||
                userData.role.includes('GoodCause')) &&
              userData.goodCauseStatus != 'Left & Removed' &&
              userData.supplierStatus != 'Left & Removed'
            "
            @click="$router.push('/admin/dashboard')"
          >
            <v-list-tile-title>Admin</v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            @click="$store.dispatch('user/logout')"
            class="pa-2"
            v-if="user.auth != null"
          >
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            @click="$router.push('/login')"
            class="pa-2"
            v-if="user.auth == null"
          >
            <v-list-tile-title>Login</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

      <v-menu v-model="on" :nudge-width="100" left>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" class="hidden-md-and-up" icon>
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>
        <v-list class="py-0">
          <v-list-tile
            v-for="(item, index) in menuMobile"
            :key="index"
            :class="{ borderBottom: index < menuMobile.length - 1 }"
            class="pa-2"
            @click="$router.push(item.route)"
          >
            <div v-if="$route.path == item.route" class="activeTab"></div>
            <v-list-tile-title>{{ item.label }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <template v-if="mobileSearch" v-slot:extension>
        <v-combobox
          v-model="searchText"
          :items="categoryServices"
          :filter="filterSearch"
          prepend-inner-icon="mdi-magnify"
          hide-no-data
          placeholder="Search products & services"
          solo
          clearable
          auto-select-first
          hide-details
          id="searchInput"
          @keyup.enter.native="doSearch()"
          @input="doSearch()"
          :menu-props="{ openOnClick: false }"
          class="roundedSearchBoxMobile"
          :class="{ 'mx-2': $vuetify.breakpoint.mdAndUp }"
          dense
        />
      </template>
    </v-toolbar>
  </div>
</template>

<script>
import { auth } from "@/fireinit.js";
import { mapGetters } from "vuex";

export default {
  data: () => ({
    mobileSearch: false,
    on: false,
    showLogout: false,

    searchLocation: "",
    menu: [
      // {
      //   label: "Giftbox",
      //   route: "/impactBoxes",
      //   icon: "mdi-gift",
      // },
      {
        label: "Upstream",
        route: "/AboutUpstream",
      },
      {
        label: "Impact Areas",
        route: "/about",
      },
      {
        label: "Good Causes",
        route: "/GoodCauses",
      },
      {
        label: "Impact Buyers",
        route: "/impactBusiness",
      },
    ],
    menuMobile: [
      // {
      //   label: "Giftbox",
      //   route: "/impactBoxes",
      //   icon: "mdi-gift",
      // },
      {
        label: "Upstream",
        route: "/AboutUpstream",
      },
      {
        label: "Impact Areas",
        route: "/about",
      },
      {
        label: "Suppliers",
        route: "/searchResults",
      },
      {
        label: "Good Causes",
        route: "/GoodCauses",
      },
      {
        label: "Impact Buyers",
        route: "/impactBusiness",
      },
    ],
    menuUser: [
      {
        label: "Login",
        route: "/login",
      },
      {
        label: "My Profile",
        route: "/userProfile",
      },
      {
        label: "Logout",
        route: "/logout",
      },
    ],
  }),
  computed: {
    ...mapGetters({
      user: "user",
      userData: "user/userData",
      categoryServices: "business/categoryServices",
      siteType: "general/siteType",
    }),
    searchText: {
      get() {
        return this.$store.state.general.toolbarSearchText;
      },
      set(value) {
        this.$store.commit("general/setToolbarSearchText", value);
      },
    },
  },
  mounted() {
    auth.onAuthStateChanged((user) => {
      if (user) {
        this.showLogout = true;
      }
    });
  },
  watch: {
    $route(value) {
      if (!value.name.includes("SearchResults")) {
        this.$store.commit("general/clearToolbarSearchText");
      }
    },
  },
  methods: {
    goToMyProfile() {
      this.$router.push("/userProfile");
    },
    goToNewBackend() {
      window.open("https://admin.upstream.co.nz/", "_blank");
    },
    onLogoClick() {
      this.$router.push("/").catch(() => {});
      this.$store.dispatch("general/changeType", "General");
    },
    toggleMenu() {
      this.on = !this.on;
    },
    onSupplierClick() {},
    filterSearch(item, queryText, itemText) {
      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text
          .toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) === 0
      );
    },
    doSearch() {
      this.$store.dispatch("general/changeType", "General");
      if (this.searchText == null) {
        this.searchText = "";
      } else {
        if (typeof this.searchText === "undefined") {
          try {
            this.$router.push(`/searchResults`);
          } catch (error) {}
        } else {
          let urlEncoded = encodeURI(this.searchText);
          try {
            this.$router.push(`/searchResults/service/${urlEncoded}`);
          } catch (error) {}
        }
      }
    },
  },
};
</script>

<style>
.activeTopNav {
  background: #ccc;
}

.userDropdown {
  background-color: #162c47 !important;
}

.userDropdown a {
  color: white;
  text-align: center;
}
</style>



<style lang="scss">
.coreToolbar {
  padding: 10px;
  border-radius: 0% !important;
  border-bottom: 2px solid white;

  .logo {
    min-width: 100px;
    max-width: 120px;
    height: 100px;
    margin-left: 15px;
  }
}

.activeTab {
  background: #4ac7e9;
  min-width: 10px;
  min-height: calc(100% + 16px);
  position: absolute;
  left: -8px;
}

.borderBottom {
  border-bottom: 1px solid #162c47;
}

.v-menu__content.theme--light.v-menu__content--fixed.menuable__content__active {
  border-radius: 0px !important;
}

.roundedSearchBox {
  max-width: 300px;
  border-radius: 50%;
  .v-input__slot {
    border-radius: 100px !important;
  }
}

.roundedSearchBoxMobile {
  min-width: 100%;
  border-radius: 50%;
  .v-input__slot {
    border-radius: 100px !important;
  }
}
</style>

<style>
#core-toolbar {
  z-index: 100;
}

.selected {
  opacity: 1 !important;
}
</style>
